import { useState, useContext } from "react";

import { Container } from "./styles";

import Logo from "../../assets/images/svg-Logo.svg";

import AdminPage from "../Admin/Dashboard";

import AuthContext from "../../contexts/sessionContext";

function Login() {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");

	const { signIn, error, setError } = useContext(AuthContext);

	const handleSubmit = async (e: any) => {
		try {
			e.preventDefault();

			if (email && password) {
				localStorage.setItem("@REALIZAR:user_email", email);
				localStorage.setItem("@REALIZAR:user_pass", password);

				await signIn();
			}
		} catch (error) {
			return error;
		}
	};

	return (
		<Container>
			<AdminPage />

			<div className='blur'>
				<form className='login-container' onSubmit={handleSubmit}>
					<div className='container-header'>
						<img src={Logo} alt='realizar_logo' />

						<div className='header-text'>
							<p id='title'>Olá, seja bem vindo!</p>
							<p id='sub-title'>
								Digite suas credenciais para continuar.
							</p>
						</div>
					</div>

					<div className='input-wrapper'>
						<input
							onChange={(e) => {
								setError("");
								setEmail(e.target.value);
							}}
							type='text'
							placeholder='Digite seu e-mail'
							className={`input ${
								error === "email_not_found" ? "error" : null
							}`}
						/>

						<input
							onChange={(e) => {
								setError("");
								setPassword(e.target.value);
							}}
							type='password'
							placeholder='Digite sua senha'
							className={`input ${
								error === "password_wrong" ? "error" : null
							}`}
						/>
					</div>

					<div className='container-bottom'>
						<div>
							<div className='checkbox-wrapper'>
								<input
									type='checkbox'
									placeholder='lembrar de mim'
								/>
								<p>Lembrar de mim</p>
							</div>

							<a href='#'>Esqueceu sua senha?</a>
						</div>

						<button type='submit'>Login</button>
					</div>
				</form>
			</div>
		</Container>
	);
}

export default Login;
